// Croqui: `components/Notice.tsx`.

import type { ReactNode } from 'react';
import { cn } from '../../lib/cn.ts';
import { Card } from './card.tsx';
import { Icon, type IconName } from './icon.tsx';
import { INK_TEXT, TONE_INK, type Tone } from './ink.ts';

const BORDER: Record<Tone, string> = {
  ok: 'border-green/30',
  wait: 'border-gold/30',
  bad: 'border-danger/30',
  neutral: 'border-muted/30',
  info: 'border-card-border',
};

/** Aviso inline. Tom seco: motivo, prazo, o que fazer. O ícone padrão vem do tom. */
export function Notice({
  tone = 'wait',
  icon,
  title,
  children,
  action,
  className,
}: {
  tone?: Tone;
  icon?: IconName;
  title: string;
  children?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  const name: IconName = icon ?? (tone === 'bad' ? 'alert' : tone === 'ok' ? 'check' : 'bell');
  return (
    <Card className={cn('flex items-start gap-3 px-3.5 py-3', BORDER[tone], className)}>
      <span className={cn('mt-px flex', INK_TEXT[TONE_INK[tone]])}>
        <Icon name={name} size={18} />
      </span>
      <div className="min-w-0 flex-1">
        <div className="text-13 font-semibold">{title}</div>
        {children !== undefined && (
          <div className="mt-0.5 text-12 text-muted leading-relaxed tabular-nums">{children}</div>
        )}
      </div>
      {action}
    </Card>
  );
}
